import React from "react";
import { Link } from "react-router-dom";

const PrivacyNav = () => {
  return (
    <nav className="bg-gray-100 p-4">
      <ul className="flex space-x-4">
        <li>
          <Link to="/" className="text-indigo-600 hover:underline">
            Dashboard
          </Link>
        </li>
        <li>
          <Link to="/profile" className="text-indigo-600 hover:underline">
            Profile
          </Link>
        </li>
        <li>
          <Link to="/privacy" className="text-indigo-600 hover:underline">
            Privacy Policy
          </Link>
        </li>
      </ul>
    </nav>
  );
};

export default PrivacyNav;
